import type { EditorCommand } from '@atlaskit/editor-common/types';

import type { RemixThinkingPluginMeta } from '../pm-plugins/remix-thinking/remix-thinking-plugin';
import { remixThinkingPluginKey } from '../pm-plugins/remix-thinking/remix-thinking-plugin';
import type { RemixThinkingLifecycleProjection } from '../ui/utils/editor-remix-lifecycle-projection';

// Internal command: not on the plugin command API, not exported.
export const setRemixThinkingLifecycle =
	(lifecycle: RemixThinkingLifecycleProjection): EditorCommand =>
	({ tr }) => {
		tr.setMeta(remixThinkingPluginKey, {
			lifecycle: { kind: 'machine-projection', ...lifecycle },
		} satisfies RemixThinkingPluginMeta);
		return tr;
	};
